// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"a2145470","592":"184f3879"}[chunkId] + ".chunk.js";
};